import { Injectable } from '@angular/core';
import { Socket } from 'socket.io-client';
import { io } from "socket.io-client";
import { ClientToServerEventsQA, MeetingListEntry, ModeratorLoginPayload, ModeratorLoginResult, ModeratorUser, SelectMeetingResult, ServerToClientEventsQA, QData, ShowNames } from '@reflact/spftypes';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  private static socket_: Socket<ServerToClientEventsQA, ClientToServerEventsQA>;
  constructor() {
  }

  public get socket(): Socket<ServerToClientEventsQA, ClientToServerEventsQA> {
    if (!SocketService.socket_) {
      const url = window.location.origin.includes('localhost') ? environment.url : window.location.origin;
      SocketService.socket_ = io(url, { path: '/api/socket.io', withCredentials: true })
    }
    return SocketService.socket_;
  }

  /**
   * Restores a moderator identity from the server-side http session (see
   * dialogue-server's ModeratorManager.restoreModeratorSession) - lets a page
   * refresh skip the login screen, since the same httpOnly session cookie is
   * shared between the initial HTTP request and this Socket.IO connection.
   */
  public restoreModeratorSession(): Promise<ModeratorLoginResult> {
    return new Promise<ModeratorLoginResult>((resolve) => {
      this.socket.emit('restoreModeratorSession', (result: ModeratorLoginResult) => resolve(result))
    })
  }

  /**
   * Logs the moderator into Adobe Connect with their own credentials (server-side
   * login, see dialogue-server's ConnectAuth.loginModerator) - replaces the old
   * pod-generated-JWT based joinModeratorClient flow entirely.
   */
  public moderatorLogin(login: string, password: string): Promise<ModeratorLoginResult> {
    const payload: ModeratorLoginPayload = { login, password };
    return new Promise<ModeratorLoginResult>((resolve) => {
      this.socket.emit('moderatorLogin', payload, (result: ModeratorLoginResult) => resolve(result))
    })
  }

  public getMeetingList(): Promise<MeetingListEntry[]> {
    return new Promise<MeetingListEntry[]>((resolve) => {
      this.socket.emit('getMeetingList', (meetings: MeetingListEntry[]) => resolve(meetings))
    })
  }

  public selectMeeting(scoId: string): Promise<SelectMeetingResult> {
    return new Promise<SelectMeetingResult>((resolve) => {
      this.socket.emit('selectMeeting', scoId, (result: SelectMeetingResult) => resolve(result))
    })
  }

  public deselectMeeting(scoId: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.socket.emit('deselectMeeting', scoId, (worked: boolean) => resolve(worked))
    })
  }

  public moderatorList(): Promise<ModeratorUser[]> {
    console.time("LoadModeratorList")
    return new Promise<ModeratorUser[]>((resolve, reject) => {
      this.socket.emit('moderatorlist', (moderators: ModeratorUser[]) => {
        console.timeEnd("LoadModeratorList")
        resolve(moderators)
      })
    })
  }

  public getQuestionList(): Promise<{ questions: QData[], workedByArray: any[] }> {
    console.time("getQuestionList")
    return new Promise<{ questions: QData[], workedByArray: any[] }>((resolve, reject) => {
      this.socket.emit('getQuestionList', (questions: QData[], workedByArray: any[]) => {
        console.timeEnd("getQuestionList")
        resolve({ questions, workedByArray })
      })
    })
  }

  public getShowNames(sessionIdentifier: string): Promise<ShowNames> {
    return new Promise<ShowNames>((resolve, reject) => {
      this.socket.emit('getShowNamesModeratorView', sessionIdentifier, (showNames: ShowNames) => {
        resolve(showNames)
      })
    })
  };

}
